import { Component, OnInit } from '@angular/core';

import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { IAuthMenu } from '../../models';
import { RequestMenu } from '../../models/messages';
import { AuthorizationService } from '../../services';

@Component({
  selector: 'app-admin-card',
  templateUrl: './admin-card.component.html',
  styleUrls: ['./admin-card.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgTemplateOutlet, NgbDropdownItem]
})

export class AdminCardComponent implements OnInit {

  menuItems: IAuthMenu[] = [];
  hasItems: boolean = false;

  constructor(protected authService: AuthorizationService) {
    // Listen for Okta authentication state changes
    // @ts-ignore: access to private property for demonstration; ideally expose OktaAuth via AuthorizationService
    const oktaAuth = (this.authService as any).oauth;
    if (oktaAuth && oktaAuth.authStateManager) {
      oktaAuth.authStateManager.subscribe((authState: any) => {
        if (authState.isAuthenticated) {
          this.refreshMenu();
        }
      });
    }
  }

  ngOnInit() {
    this.refreshMenu();
  }

  refreshMenu(): void {
    let req: RequestMenu = new RequestMenu();
    req.hierarchyCode = "admin";

    this.authService.isAuthenticated().then(isAuth => {
      if (isAuth) {
        this.authService.menuGet$(req).subscribe((data: IAuthMenu[]) => {
          this.menuItems = data;
          this.hasItems = (this.menuItems.length > 0);
        });
      }
    });
  }

  isItemRouteInternal(url: string): boolean {

    if (url.startsWith("http"))
      return false;
    else
      return true;
  }
}
